// tools.ts

export interface ToolFunction {
    name: string;
    description: string;
    parameters: Record<string, unknown>;
    execute: (args: any) => Promise<any>;
}

// Define your available tools
const tools: ToolFunction[] = [
    {
        name: "logMessage",
        description: "Logs a message to the console.",
        parameters: {
            message: { type: "string", description: "The message to log" }
        },
        execute: async args => {
            console.log("[Tool] logMessage executed with:", args.message);
            return { success: true };
        }
    },
    {
        name: "getCurrentTime",
        description: "Gets the current server time.",
        parameters: {},
        execute: async () => {
            const currentTime = new Date().toLocaleTimeString();
            console.log("[Tool] getCurrentTime executed:", currentTime);
            return { time: currentTime };
        }
    }
];

// Return only the definitions (name, description, parameters) required by the session update
export function getToolDefinitions() {
    return tools.map(({ name, description, parameters }) => ({
        name,
        description,
        parameters
    }));
}

// Helper function to execute a tool based on its name
export async function executeTool(name: string, args: any) {
    const tool = tools.find(tool => tool.name === name);
    if (!tool) {
        console.error(`[Tool] No tool found with name: ${name}`);
        return null;
    }
    return await tool.execute(args);
}
